import styles from './AttachmentsTabPanel.module.scss';

import React from 'react';

import { Attachments } from '@work4all/components/lib/components/attachments';

import { useTableLayoutState } from '../../../../../../../../components/data-tables/table-layout';
import { Panel } from '../../../../../components/panel/Panel';

export const AttachmentsTabPanel = () => {
  const [tableLayout] = useTableLayoutState();
  return (
    <Panel className={styles.maxHeight}>
      <Attachments tableLayout={tableLayout} />
    </Panel>
  );
};
